import { createAction } from 'redux-actions';

export interface SaveSeatServicesPayload {
	onSuccess?: () => void;
}

export const SAVE_SEAT_SERVICES = 'SAVE_SEAT_SERVICES';

export const saveSeatServices = createAction<SaveSeatServicesPayload>(SAVE_SEAT_SERVICES);
